import React from 'react';
import { Skeleton, EventCardSkeleton, PreviewCardSkeleton, RecurrencePatternSkeleton } from '../primitives/SkeletonLoader';

const SkeletonSection: React.FC = () => {
  return (
    <section className="component-section">
      <p className="section-description">
        Les composants Skeleton offrent un feedback visuel élégant pendant le chargement des données.
      </p>

      <div className="controls-showcase">
        {/* Basic Skeleton Variants */}
        <div className="control-type-container">
          <div className="control-group">
            <h4>Basic Skeleton Components</h4>
            <p className="control-description">
              Variants de base pour différents types de contenu avec animation shimmer.
            </p>
            <div className="control-preview">
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', maxWidth: '300px' }}>
                <div>
                  <h5>Text Skeleton</h5>
                  <Skeleton variant="text" />
                </div>
                <div>
                  <h5>Title Skeleton</h5>
                  <Skeleton variant="title" />
                </div>
                <div>
                  <h5>Button Skeleton</h5>
                  <Skeleton variant="button" width="120px" />
                </div>
                <div>
                  <h5>Image Skeleton</h5>
                  <Skeleton variant="image" height="100px" />
                </div>
                <div>
                  <h5>Recurrence Pattern Skeleton</h5>
                  <RecurrencePatternSkeleton />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Event Card Skeletons */}
        <div className="control-type-container">
          <div className="control-group">
            <h4>Event Card Skeletons</h4>
            <p className="control-description">
              Templates complets pour les cartes d'événements.
            </p>
            <div className="control-preview">
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', maxWidth: '400px' }}>
                <div>
                  <h5>Simple Event Card</h5>
                  <EventCardSkeleton variant="simple" />
                </div>
                <div>
                  <h5>Recurring Event Card</h5>
                  <EventCardSkeleton variant="recurring" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Preview Card Skeleton */}
        <div className="control-type-container">
          <div className="control-group">
            <h4>Preview Card Skeleton</h4>
            <p className="control-description">
              Template pour les cartes de prévisualisation dans les drawers.
            </p>
            <div className="control-preview">
              <div style={{ maxWidth: '400px' }}>
                <PreviewCardSkeleton />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkeletonSection; 